<template>
  <layout>
    <template v-slot:title>
      <h1 class="sf-sb">{{ $t('offices-page.page-title') }}</h1>
    </template>

    <main-office-contact
      class="sf-mb"
      :title="$t('offices-page.main')"/>

    <offline-office-contact
      v-for="(office, index) in offices"
      :key="`office-${index+1}`"
      :office="office"/>
  </layout>
</template>

<script>
import Clock from '~/static/img/icons/clock-time.svg';
import Location from '~/static/img/icons/location.svg';
import Layout from '~lib/src/layouts/blank';
import MainOfficeContact from '~/components/contacts/main-office-contact.vue';
import OfflineOfficeContact from '~/components/contacts/offline-office-contact.vue';

export default {
  name: 'OfficesPage',
  components: { OfflineOfficeContact, MainOfficeContact, Layout },

  computed: {
    offices() {
      return [
        {
          title: this.$t('offices-page.office1-title'),
          data: [
            {
              logo: Clock,
              title: this.$t(`offices-page.working-hours-title`),
              daysText: this.$t(`offices-page.working-days`),
              hoursText: this.$t(`offices-page.working-hours-1`),
            },
            {
              logo: Location,
              title: this.$t(`offices-page.location-title`),
              address: this.$t(`offices-page.location-1`),
              isMap: true,
            },
          ],
          mapImage: 'offline-office-1',
        },
        {
          title: this.$t('offices-page.office2-title'),
          data: [
            {
              logo: Clock,
              title: this.$t(`offices-page.working-hours-title`),
              daysText: this.$t(`offices-page.working-days`),
              hoursText: this.$t(`offices-page.working-hours-2`),
            },
            {
              logo: Location,
              title: this.$t(`offices-page.location-title`),
              address: this.$t(`offices-page.location-2`),
              isMap: true,
            },
          ],
          mapImage: 'offline-office-2',
        },
        {
          title: this.$t('offices-page.office3-title'),
          data: [
            {
              logo: Clock,
              title: this.$t(`offices-page.working-hours-title`),
              daysText: this.$t(`offices-page.working-days`),
              hoursText: this.$t(`offices-page.working-hours-3`),
            },
            {
              logo: Location,
              title: this.$t(`offices-page.location-title`),
              address: this.$t(`offices-page.location-3`),
              isMap: true,
            },
          ],
          mapImage: 'offline-office-3',
        },
        {
          title: this.$t('offices-page.office4-title'),
          data: [
            {
              logo: Clock,
              title: this.$t(`offices-page.working-hours-title`),
              daysText: this.$t(`offices-page.working-days`),
              hoursText: this.$t(`offices-page.working-hours-4`),
            },
            {
              logo: Location,
              title: this.$t(`offices-page.location-title`),
              address: this.$t(`offices-page.location-4`),
              isMap: true,
            },
          ],
          mapImage: 'offline-office-4',
        },
      ];
    },
  },
};
</script>
